import { Button, Drawer, Flex, Tooltip } from '@buffer-mono/popcorn'

import {
  DateRangePickerContent,
  DateRangePickerDateInputs,
  useDateRangePickerState,
} from '~publish/components/DateRangePicker'

import type { JSX } from 'react'

interface DateRangeDrawerProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  initialRange?: { startDate: Date; endDate: Date }
  onApply: (startDate: Date, endDate: Date) => void
  weekStartsOn?: 0 | 1
}

export function DateRangeDrawer({
  open,
  onOpenChange,
  initialRange,
  onApply,
  weekStartsOn,
}: DateRangeDrawerProps): JSX.Element {
  const state = useDateRangePickerState({
    open,
    onOpenChange,
    initialRange,
    onApply,
    weekStartsOn,
    singleMonth: true,
  })

  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <Drawer.Content>
        <Drawer.Header>
          <Drawer.Title>Custom date range</Drawer.Title>
        </Drawer.Header>
        <Drawer.Body>
          <DateRangePickerContent
            state={state}
            weekStartsOn={weekStartsOn}
            numberOfMonths={1}
            fullWidth
          />
          <DateRangePickerDateInputs state={state} />
        </Drawer.Body>
        <Drawer.Footer>
          <Flex gap="xs" justify="end">
            <Drawer.Close>
              <Button variant="tertiary" size="medium">
                Cancel
              </Button>
            </Drawer.Close>
            <Tooltip
              content={state.applyDisabledReason}
              open={state.applyDisabledReason ? undefined : false}
            >
              <Button
                variant="primary"
                size="medium"
                onClick={state.handleApply}
                disabled={state.isApplyDisabled}
              >
                Apply
              </Button>
            </Tooltip>
          </Flex>
        </Drawer.Footer>
      </Drawer.Content>
    </Drawer>
  )
}
